import React from 'react';
import { PURCHASE_ORDER_STATUSES_OPTIONS } from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import CreatePurchaseOrderButton from 'domain/finance/purchaseOrder/shared/button/CreatePurchaseOrderButton';
import PurchaseOrderLink from 'domain/finance/purchaseOrder/shared/field/PurchaseOrderLink';
import ViewPurchaseOrderButton from 'domain/finance/purchaseOrder/shared/button/ViewPurchaseOrderButton';
import { DateField, EnumField, SearchResultField, TextField } from 'framework/ui/field';
import PurchaseOrderStatusFilter from 'domain/finance/purchaseOrder/shared/filter/PurchaseOrderStatusFilter';
import PurchaseOrderTypeFilter from 'domain/finance/purchaseOrder/shared/filter/PurchaseOrderTypeFilter';
import ListPageHeaderWrapper from 'domain/finance/shared/ListPageHeaderWrapper';
import PurchaseOrderTotalField from 'domain/finance/purchaseOrder/shared/field/PurchaseOrderTotalField';
import PurchaseOrderTypeField from 'domain/finance/purchaseOrder/shared/field/PurchaseOrderTypeField';
import { DataGridLayout, Filters, FiltersLayout, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import { OfficeCodeFilter } from 'domain/shared/employee';

const PurchaseOrderListPageContent = ({
  isSensitiveDataIsShown,
  toggleSensitiveDataButton,
}: {
  isSensitiveDataIsShown?: boolean;
  toggleSensitiveDataButton?: Nullable<React.ReactElement>;
}) => {
  const filters = (
    <Filters>
      <FiltersLayout>
        <PurchaseOrderStatusFilter label="Status" source="status" />
        <PurchaseOrderTypeFilter label="Type" source="type" />
        <OfficeCodeFilter source="office" label="Office" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <ListPageLayout
      header={
        <ListPageHeaderWrapper header={<ListHeader label="Purchase Orders" />} actions={[toggleSensitiveDataButton]} />
      }
      actions={[<CreatePurchaseOrderButton />]}
      filter={filters}
      search={<SearchInput label="title" />}
    >
      <DataGridLayout buttons={[<ViewPurchaseOrderButton source="id" />]}>
        {
          [
            <PurchaseOrderLink source="id" nameSource="id" label="Purchase order ID" width="15%" />,
            <PurchaseOrderTypeField source="type" label="Type" width="95px" />,
            <SearchResultField source="title" label="Title" width="20%" />,
            <TextField source="vendor" label="Vendor" width="20%" />,
            isSensitiveDataIsShown ? <PurchaseOrderTotalField label="Total" source="subTotal" width="17%" /> : null,
            <EnumField label="Status" source="status" options={PURCHASE_ORDER_STATUSES_OPTIONS} width="95px" />,
            <DateField source="requiredDeliveryDate" label="Required delivery date" width="150px" />,
            <DateField source="expirationDate" label="Expiration date" width="120px" />,
            <TextField source="purchasePurpose" label="Purchase purpose" width="25%" />,
          ].filter(Boolean) as React.ReactElement[]
        }
      </DataGridLayout>
    </ListPageLayout>
  );
};

export default PurchaseOrderListPageContent;
